import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  IDevisCollaborateur,
  IUpdateDevisCollaborateursRequest
} from 'src/app/shared/models/devis-collaborateur';

@Injectable({ providedIn: 'root' })
export class DevisCollaborateurService {

  private readonly apiUrl = '/api/v1/devis';

  constructor(private http: HttpClient) {}

  getCollaborateurs(devisId: string): Observable<IDevisCollaborateur[]> {
    return this.http.get<IDevisCollaborateur[]>(`${this.apiUrl}/${devisId}/collaborateurs`);
  }

  updateCollaborateurs(devisId: string, request: IUpdateDevisCollaborateursRequest): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${devisId}/collaborateurs`, request);
  }
}
